import { Box, Step, StepLabel, Stepper, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useCreateProjectWizardSteps } from '../hooks/useCreateProjectWizardSteps';
import { selectActiveStep } from '../state/selector';

export const WizardSidebar = () => {
  const theme = useTheme();
  const activeStep = useAppSelector(selectActiveStep);
  const steps = useCreateProjectWizardSteps();
  const { formatMessage } = useIntl();
  return (
    <Box id="wizard-sidebar" sx={{ width: '350px', pt: theme.spacing(4) }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((stepKey) => (
          <Step key={stepKey}>
            <StepLabel>
              {formatMessage({ id: `createProjectWizard.step.${stepKey}.title` })}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
